module.exports = __webpack_public_path__ + "static/media/needimg3.4a3adabd.jpg";